import React, { useState, useEffect } from "react";
import Modal from "../layout/Modal";

export default function RouteEditor({
    draftRoute,
    onUpdateStops,
    onAddPoint,
    onSave,
    onCancel
}) {
  // Local state isolates typing from the rest of the app
  const [localName, setLocalName] = useState(draftRoute.name || "");
  const [localInput, setLocalInput] = useState({ lat: "", lon: "", pop: "" });


  const [errorModal, setErrorModal] = useState({ isOpen: false, message: "" });

  const closeErrorModal = () => setErrorModal({ ...errorModal, isOpen: false })

  // Reset local name when draft is cleared from parent
  useEffect(() => {
    if (!draftRoute.name) setLocalName("");
  }, [draftRoute.name]);

const handleAddClick = () => {
      if (!localInput.lat || !localInput.lon) return;

      onAddPoint(parseFloat(localInput.lat), parseFloat(localInput.lon), 0);

      setLocalInput(prev => ({ ...prev, lat: "", lon: "" }));
  };

  const handleSaveClick = () => {
      onSave(localName);
  };

const handleWeightChange = (stopId, newVal) => {
      const val = parseInt(newVal);

      if (val < 0) {
          setErrorModal({
              isOpen: true,
              message: "El peso de la parada no puede ser negativo."
          });
          return;
      }

      const finalVal = isNaN(val) ? 0 : val;

      const updatedStops = draftRoute.stops.map(s =>
          s.id === stopId ? { ...s, population: finalVal } : s
      );
      onUpdateStops(updatedStops);
  };

  return (
    <div style={styles.editorBox}>
      <div style={styles.editorHeader}>
          <span style={{fontWeight:'bold', color:'#B45309'}}>Editando...</span>
          <span onClick={onCancel} style={{cursor:'pointer', fontSize:12, color:'#9CA3AF'}}>Cancelar</span>
      </div>
      
      <input
        type="text"
        placeholder="Nombre Ruta"
        style={styles.input}
        value={localName}
        onChange={e => setLocalName(e.target.value)}
      />

      <div style={{display:'flex', gap: 5, marginBottom: 8}}>
         <input type="number" placeholder="Latitud" style={styles.inputSmall} value={localInput.lat} onChange={e => setLocalInput({...localInput, lat:e.target.value})} />
         <input type="number" placeholder="Longitud" style={styles.inputSmall} value={localInput.lon} onChange={e => setLocalInput({...localInput, lon:e.target.value})} />
         <button style={styles.actionBtn} onClick={handleAddClick}>Ir</button>
      </div>

      <div style={styles.pointsList}>
        {draftRoute.stops.length === 0 && <p style={{fontSize:11, color:'#9CA3AF', textAlign:'center', marginTop:10}}>Toca el mapa para agregar una parada...</p>}
        {draftRoute.stops.map((stop, idx) => (
          <div key={stop.id} style={styles.pointRow}>
             <div style={{display:'flex', alignItems:'center', gap: 8, flex: 1}}>
               <span style={styles.indexCircle}>{idx + 1}</span>
               <div style={{display:'flex', flexDirection:'column', width: '100%', marginLeft: 10}}>
                 <label style={{fontSize: 12, color: '#374151', fontWeight: 600, marginBottom: 4}}>{stop.name}</label>
                 <div style={{display:'flex', alignItems:'center', width: '100%'}}>
                     <label style={{fontSize: 10, color: '#9CA3AF', marginRight: 4}}>Peso:</label>
                     <input 
                       type="number" min="0" placeholder="0"
                       value={stop.population === 0 ? '' : stop.population}
                       onChange={e => !stop.isShared && handleWeightChange(stop.id, e.target.value)} 
                       onWheel={(e) => e.target.blur()}
                       disabled={stop.isShared}
                       style={{
                           ...styles.weightInput,
                           flex: 1, 
                           backgroundColor: stop.isShared ? '#F3F4F6' : 'white',
                           color: stop.isShared ? '#9CA3AF' : 'black',
                           cursor: stop.isShared ? 'not-allowed' : 'text'
                       }}
                     />
                 </div>
               </div>
             </div>
             {/* Parent owns deletion because it must update the map graphics */}
             <div onClick={() => onUpdateStops(draftRoute.stops.filter(s => s.id !== stop.id))} style={styles.deleteBtn}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
             </div>
          </div>
        ))}
      </div>
      
      <button style={styles.saveBtn} onClick={handleSaveClick}>Guardar Ruta</button>
      <Modal 
        isOpen={errorModal.isOpen}
        title="Error de Validación"
        message={errorModal.message}
        type="error"
        onClose={closeErrorModal}
      />
    </div>
  );
}

const styles = {
  editorBox: { padding: 16, borderRadius: 12, backgroundColor: '#FFFBEB', border: '2px dashed #EAC024', display: 'flex', flexDirection: 'column', gap: 10, position: 'relative' },
  editorHeader: { display: 'flex', justifyContent: 'space-between', marginBottom: 5 },
  input: { width: '100%', padding: '8px 12px', borderRadius: 6, border: '1px solid #D1D5DB', fontSize: 13, outline:'none' },
  inputSmall: { flex: 1, minWidth: 0, padding: '8px 8px', borderRadius: 6, border: '1px solid #D1D5DB', fontSize: 12, outline:'none' },
  actionBtn: { padding: '0 12px', borderRadius: 6, border: 'none', backgroundColor: '#EAC024', color: 'white', fontWeight: 'bold', cursor: 'pointer' },
  pointsList: { maxHeight: 150, overflowY: 'auto', backgroundColor: 'white', borderRadius: 6, border: '1px solid #E5E7EB', padding: 8, marginBottom: 5 },
  pointRow: { display:'flex', justifyContent:'space-between', alignItems:'center', fontSize:12, padding:'10px 0', borderBottom:'1px solid #F3F4F6' },
  saveBtn: { width: '100%', padding: 10, borderRadius: 8, border: 'none', backgroundColor: '#EAC024', color: 'white', fontWeight: 'bold', cursor: 'pointer' },
  indexCircle: { width: 22, height: 22, borderRadius: '50%', backgroundColor: '#EAC024', color: 'white', fontSize: 11, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', flexShrink: 0 },
  weightInput: { padding: '4px 8px', borderRadius: 6, border:'1px solid #D1D5DB', fontSize: 12, outline: 'none', width: '100%' },
  deleteBtn: { width: 28, height: 28, borderRadius: '6px', backgroundColor: '#FFF1F2', border: '1px solid #FECDD3', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#E11D48', transition: 'all 0.2s ease', marginLeft: 10 },
};